﻿﻿﻿﻿<div class="app-container">
  <pm-shell-top-bar />

  <pm-shell-global-search />

  <pm-shell-profile-menu />

  <pm-shell-app-launcher />

  <pm-shell-quick-add />

  <!-- Shown by each page's @defer @loading block while that page's lazy chunk downloads on first visit
       (only after 150ms, so a fast or cached load shows nothing). -->
  <ng-template #pmPageDeferSkeleton>
    <div class="pm-page-defer-skeleton" aria-busy="true" aria-label="Loading">
      <pm-skeleton width="220px" height="22px" radius="6px" />
      <div class="pm-page-defer-skeleton__toolbar">
        <pm-skeleton width="260px" height="34px" radius="8px" />
        <pm-skeleton width="120px" height="34px" radius="8px" />
      </div>
      @for (i of [0, 1, 2, 3, 4, 5, 6, 7]; track i) {
      <pm-skeleton [width]="(70 + (i % 3) * 10) + '%'" height="14px" />
      }
    </div>
  </ng-template>

  <main class="content-area" aria-label="Workspace content" [pmSmoothScroll]="activeItem() === 'Dashboard'" [class.content-area--clients]="activeItem() === 'Clients' || activeItem() === 'Document Hub' || activeItem() === 'CompaniesHouseClients'" [class.content-area--task-detail]="activeItem() === 'Tasks' && !!taskDetailId()" [class.content-area--deadlines]="activeItem() === 'Deadlines'" [class.content-area--clients-table-bounded]="clientsTableBoundedActive()">
    <!-- Page Content will go here -->
    <div class="dashboard-shell">
      @if (activeItem() === 'Notifications') {
      @defer (on immediate) {
      <pm-notifications-page />
      } @loading (after 150ms; minimum 300ms) {
      <ng-container *ngTemplateOutlet="pmPageDeferSkeleton" />
      }

      } @else if (activeItem() === 'Announcements') {
      @defer (on immediate) {
      <pm-announcements-page />
      } @loading (after 150ms; minimum 300ms) {
      <ng-container *ngTemplateOutlet="pmPageDeferSkeleton" />
      }

      } @else if (activeItem() === 'Dashboard') {
      @defer (on immediate) {
      <pm-dashboard-page />
      } @loading (after 150ms; minimum 300ms) {
      <ng-container *ngTemplateOutlet="pmPageDeferSkeleton" />
      }
      }
    </div>

    @if (activeItem() === 'Document Hub') {
    @defer (on immediate) {
    <pm-document-hub-page #documentHubPage [clientsDirectoryRowsState]="clientsDirectoryRows" [clientsBookMeetingPickerRowsState]="clientsBookMeetingPickerRows" [filteredClientRowsState]="filteredClientRows" />
    } @loading (after 150ms; minimum 300ms) {
    <ng-container *ngTemplateOutlet="pmPageDeferSkeleton" />
    }
    }


    <!-- Clients Page -->
    @if (activeItem() === 'Clients') {
    @if (clientDetailId()) {
    <!-- The real client page (same as /clients/:id), inside the workspace so it keeps the app's own
         header, popovers and FAB. It reads the client id from the route itself. -->
    @defer (on immediate) {
    <pm-client-detail-page [embedded]="true" />
    } @loading (after 150ms; minimum 300ms) {
    <ng-container *ngTemplateOutlet="pmPageDeferSkeleton" />
    }
    } @else {
    <div class="clients-screen">
        <pm-clients-subnav />

      <div class="clients-screen-inner" [class.clients-screen-inner--table-bounded]="clientsTableBoundedActive()">
        @if (clientsWorkspaceSection() === 'list') {
        @if (clientsPageView() === 'clients') {
        @defer (on immediate) {
        <pm-clients-toolbar />
        }
        }



        @if (clientsPageView() === 'drafts') {
        @defer (on immediate) {
        <pm-clients-drafts />
        } @loading (after 150ms; minimum 300ms) {
        <ng-container *ngTemplateOutlet="pmPageDeferSkeleton" />
        }
        }
        @if (clientsPageView() === 'unassigned') {
        @defer (on immediate) {
        <pm-clients-unassigned />
        } @loading (after 150ms; minimum 300ms) {
        <ng-container *ngTemplateOutlet="pmPageDeferSkeleton" />
        }
        }
        @if (clientsPageView() === 'clients' && clientsPageTab() === 'clients') {
        @defer (on immediate) {
        <pm-clients-directory />
        } @loading (after 150ms; minimum 300ms) {
        <ng-container *ngTemplateOutlet="pmPageDeferSkeleton" />
        }
        }
        @if (clientsPageView() === 'clients' && clientsPageTab() === 'users') {
        @defer (on immediate) {
        <pm-clients-users />
        } @loading (after 150ms; minimum 300ms) {
        <ng-container *ngTemplateOutlet="pmPageDeferSkeleton" />
        }
        }
        }

        @if (clientsWorkspaceSection() === 'schedule') {
        @defer (on immediate) {
        <pm-clients-schedule />
        } @loading (after 150ms; minimum 300ms) {
        <ng-container *ngTemplateOutlet="pmPageDeferSkeleton" />
        }
        }

        @if (clientsWorkspaceSection() === 'communication') {
        @defer (on immediate) {
        <pm-clients-communication />
        } @loading (after 150ms; minimum 300ms) {
        <ng-container *ngTemplateOutlet="pmPageDeferSkeleton" />
        }
        }

        @if (clientsWorkspaceSection() === 'submissions') {
        @defer (on immediate) {
        <pm-clients-submissions />
        } @loading (after 150ms; minimum 300ms) {
        <ng-container *ngTemplateOutlet="pmPageDeferSkeleton" />
        }
        }

        @if (clientsWorkspaceSection() === 'letters') {
        @defer (on immediate) {
        <pm-letters-page [clientPickerOptions]="clientsPickerClients()" />
        } @loading (after 150ms; minimum 300ms) {
        <ng-container *ngTemplateOutlet="pmPageDeferSkeleton" />
        }
        }

        @if (clientsWorkspaceSection() === 'aml') {
        @defer (on immediate) {
        <pm-clients-aml />
        } @loading (after 150ms; minimum 300ms) {
        <ng-container *ngTemplateOutlet="pmPageDeferSkeleton" />
        }
        }

        @if (isClientsComingSoonWorkspace()) {
        <div class="clients-workspace-placeholder">
          <p class="clients-workspace-placeholder-text">This section is coming soon.</p>
        </div>
        }


        @defer (on immediate) {
        <pm-clients-list-popups />
        }


      </div>
    </div>
    }
    }

    <!-- Deadlines Page -->
    @if (activeItem() === 'Deadlines') {
    <!-- Every pm-deadlines-management-hub / pm-task-management-hub use in this file sits inside a @defer,
         so both hubs stay out of the initial bundle (one use outside a @defer would pull it back in). -->
    @defer (on immediate) {
    <pm-deadlines-management-hub />
    <!-- Host the shared Add Task modal so "+ Add Task" in the Add Deadline modal opens the same form as the Tasks screen.
         modalOnly skips background task-list/analytics loads. The host renders nothing when idle and its modal is a
         fixed overlay, so flex:0/height:0 keeps it from stealing layout space from the deadlines table. -->
    <pm-task-management-hub [modalOnly]="true" style="flex:0 0 0px;height:0;min-height:0;overflow:visible" />
    } @loading (after 150ms; minimum 300ms) {
    <ng-container *ngTemplateOutlet="pmPageDeferSkeleton" />
    }
    }

    <!-- Tasks Page -->
    @if (activeItem() === 'Tasks') {
      @defer (on immediate) {
      @if (taskDetailId()) {
      <pm-task-details-page [taskId]="taskDetailId()!" />
      <pm-task-management-hub [modalOnly]="true" />
      } @else {
      <pm-task-management-hub />
      }
      <!-- Host the deadlines hub so clicking "Yes" in the Deadline column opens the detail modal in-place.
           dl-hub-modal-only-host: its default List view's :host.dl-hub-list-bounded rule uses !important
           flex/overflow (for the real Deadlines page's bounded card), which otherwise beats this plain
           inline style and re-expands this hidden instance into visible layout — see that class's rule
           in pm-deadlines-management-hub.component.css for the override that keeps it collapsed. -->
      <pm-deadlines-management-hub class="dl-hub-modal-only-host" style="flex:0 0 0px;height:0;min-height:0;overflow:hidden" />
      } @loading (after 150ms; minimum 300ms) {
      <ng-container *ngTemplateOutlet="pmPageDeferSkeleton" />
      }
    }

    @if (activeItem() === 'Practice') {
    @defer (on immediate) {
    <pm-practice-page />
    } @loading (after 150ms; minimum 300ms) {
    <ng-container *ngTemplateOutlet="pmPageDeferSkeleton" />
    }
    }

    <!-- Mounted only while one of its own popups is open (pm-ui Frontend Audit PERF-19/ARCH-03),
         instead of existing for the whole session — its content is already gated by the same 5
         signals @defer (on immediate) prefetches the chunk once, on first open. -->
    @if (clientsAddFlowVisible()) {
    @defer (on immediate) {
    <pm-clients-add-flow />
    }
    }

    <!-- Mounted only while open (pm-ui Frontend Audit PERF-19/ARCH-03): its own template already
         gates all content on this same signal, and every local field it resets on open/close
         (step, file name, preview rows, progress %, columns detected) is already overwritten fresh
         at the point it's read rather than carried over, so a new instance behaves the same as the
         one reused today. -->
    @if (clientsImportModalOpen()) {
    @defer (on immediate) {
    <pm-clients-import-modal />
    }
    }

    @if (clientsCapiumPayInviteModalOpen()) {
    @defer (on immediate) {
    <pm-clients-capium-pay-invite />
    }
    }


    @if (activeItem() === 'Support Tickets') {
    @defer (on immediate) {
    <pm-practice-support-tickets />
    } @loading (after 150ms; minimum 300ms) {
    <ng-container *ngTemplateOutlet="pmPageDeferSkeleton" />
    }
    }

    @if (activeItem() === 'Analytics') {
    @defer (on immediate) {
    <pm-practice-analytics-page />
    } @loading (after 150ms; minimum 300ms) {
    <ng-container *ngTemplateOutlet="pmPageDeferSkeleton" />
    }
    }

    <!-- Companies House Clients Page -->
    @if (activeItem() === 'CompaniesHouseClients') {
    @defer (on immediate) {
    <pm-companies-house-clients-page [activeItemState]="activeItem" [activeDropdownState]="activeDropdown" (dropdownToggle)="toggleDropdown($event.id, $event.event)" />
    } @loading (after 150ms; minimum 300ms) {
    <ng-container *ngTemplateOutlet="pmPageDeferSkeleton" />
    }
    }


    <!-- CRM Page -->
    @if (activeItem() === 'CRM') {
    @defer (on immediate) {
    <pm-crm-page />
    } @loading (after 150ms; minimum 300ms) {
    <ng-container *ngTemplateOutlet="pmPageDeferSkeleton" />
    }
    }

    <!-- Reports Page -->
    @if (activeItem() === 'Reports') {
      @defer (on immediate) {
      <pm-reports-page [runnerSlug]="reportsRunnerSlug()" />
      @if (reportsRunnerSlug(); as slug) {
      <pm-report-runner [reportSlug]="slug" />
      }
      } @loading (after 150ms; minimum 300ms) {
      <ng-container *ngTemplateOutlet="pmPageDeferSkeleton" />
      }
    }

    @if (activeItem() === 'CapiSign') {
    @defer (on immediate) {
    <pm-capisign-coming-soon />
    } @loading (after 150ms; minimum 300ms) {
    <ng-container *ngTemplateOutlet="pmPageDeferSkeleton" />
    }
    }

    @if (activeItem() === 'Profile') {
    @defer (on immediate) {
    <pm-profile-page />
    } @loading (after 150ms; minimum 300ms) {
    <ng-container *ngTemplateOutlet="pmPageDeferSkeleton" />
    }
    }

    @if (activeItem() === 'Forgot Password') {
    @defer (on immediate) {
    <pm-forgot-password-page />
    } @loading (after 150ms; minimum 300ms) {
    <ng-container *ngTemplateOutlet="pmPageDeferSkeleton" />
    }
    }

    @if (activeItem() === 'Settings') {
    @defer (on immediate) {
    <pm-settings-page #settingsPage />
    } @loading (after 150ms; minimum 300ms) {
    <ng-container *ngTemplateOutlet="pmPageDeferSkeleton" />
    }
    }
    </main>

    <pm-workspace-fab></pm-workspace-fab>

    <!--
      PERF-14 - warm the next page's chunk while the browser is idle.

      Every page above sits in `@defer (on immediate)` inside an `@if (activeItem() === ...)`, so its
      block does not exist until you are already on that page: the chunk only starts downloading once
      you have switched, and you watch the skeleton while it arrives. These blocks exist from the
      start and never render (`when false`); `prefetch on idle` downloads the very same chunks during
      idle time, so the switch is instant.

      Rendering is unchanged - the @if/@defer blocks above still decide what is on screen, and these
      only move the download earlier. The compiler points both at one chunk per page, so nothing is
      fetched twice.

      Deliberately only the four heaviest pages a user reaches from the top nav, not all of them:
      prefetching every page would pull several MB on idle, which is not a fair trade on a metered
      connection. Add a line here to widen it.
    -->
    @defer (when false; prefetch on idle) {
      <pm-deadlines-management-hub />
    }
    @defer (when false; prefetch on idle) {
      <pm-task-management-hub />
    }
    @defer (when false; prefetch on idle) {
      <pm-practice-page />
    }
    @defer (when false; prefetch on idle) {
      <pm-crm-page />
    }
  </div>
